import axios from 'axios'
import { _auth } from './auth'

// create an axios instance
const service = axios.create({
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        const auth = _auth()
        config.headers['Auth'] = auth
        return config
    },
    error => {
    // do something with request error
    // console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

    /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
    response => {
        const res = response.data
        return res
    },
    error => {
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/service/request.js